import _ from 'lodash';

import formListConstants from './constants';

const initialState = {
  isInitializing: false,
  isCreatingForm: false,
  forms: [],
  newFormId: ''
};

const formListReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case formListConstants.INITIALIZE_FORM_LIST:
      return _.merge({}, state, { isInitializing: true });

    case formListConstants.INITIALIZE_FORM_LIST_SUCCESS:
    {
      const { forms } = payload;
     
      const updatedState = _.cloneDeep(state);
      updatedState.isInitializing = false;
      updatedState.forms = forms;

      return _.extend({}, state, updatedState);
    }

    case formListConstants.INITIALIZE_FORM_LIST_ERROR:
      return _.merge({}, state, { isInitializing: false });
    
    case formListConstants.CREATE_FORM:
      return _.merge({}, state, { isCreatingForm: true });

    case formListConstants.CREATE_FORM_SUCCESS:
    {
      const updatedState = {
        isCreatingForm: false,
        newFormId: payload.formId
      };

      return _.merge({}, state, updatedState);
    }
    case formListConstants.CREATE_FORM_ERROR:
      return _.merge({}, state, { isCreatingForm: false });
   
    case formListConstants.CLEAR_NEW_FORMID:
      return _.merge({}, state, { newFormId: '' });

    default:
      return state;
  }
};

export default formListReducer;
